import { Avatar, Box, Card, Grid, IconButton, styled, Typography } from '@material-ui/core';
import { EditRounded, HighlightOffOutlined } from '@material-ui/icons';
import { Rating } from '@material-ui/lab';
import { postTestimonials } from 'adapters';
import { FreeTrialDialog } from 'components/shared/free-trial-dialog';
import { theme } from 'material-theme';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetConfigData } from 'store/config/selectors';
import { GetUrlBuilderData, SetUrlBuilderData, Testimonial } from 'store/url-builder';
import { TestimonialsDialog } from '../../testimonials-dialog';
import styles from './testimonial-carousel-item.module.scss';

export interface TestimonialCarouselItemProps {
    testimonial: Testimonial;
    color: string;
    cardId: number;
    idx: number;
    readonly?: boolean;
    builderType: string;
    isFree?: boolean | null;
}

export const TestimonialCarouselItem = ({ testimonial, color, cardId, idx, readonly, builderType, isFree = null }: TestimonialCarouselItemProps) => {
    const confData = useSelector(GetConfigData);
    const builderData = useSelector(GetUrlBuilderData);
    const [dialog, setDialog] = useState(false);
    const [edtTestimonial, setEditTesti] = useState(testimonial);
    const [freeTrialDialog, setFreeTrialDialog] = useState(false);
    const openFreeTrialDialog = () => setFreeTrialDialog(true);
    const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);

    const openDialog = () => {
        setDialog(true);
    };

    const handleDialogClose = () => setDialog(false);

    const StyledRating = styled(Rating)({
        '& .MuiRating-iconFilled': {
            color: color,
        },
        '& .MuiRating-iconHover': {
            color: color,
        },
    });

    const dispatch = useDispatch();

    const editTestimonial = async (idx: number) => {
        setEditTesti(builderData.testimonials[idx]);
        openDialog();
    };

    const removeTestimonial = async (idx: number) => {
        var testimonials = builderData.testimonials;
        testimonials = testimonials.filter((_, index) => index !== idx);
        const builderResponse = (await postTestimonials('' + cardId, builderType, testimonials)).data;
        if (!builderResponse.success) throw new Error(builderResponse.message);
        dispatch(SetUrlBuilderData(builderResponse.data));
    };

    return (
        <>
            <Box className='ml-2 mr-2 h-100'>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {!readonly && (
                            <>
                                <IconButton
                                    style={{ color: theme.palette.warning.main, position: 'absolute', zIndex: 2, top: '0px', right: '40px' }}
                                    onClick={() => {
                                        if (isFree) openFreeTrialDialog();
                                        else editTestimonial(idx);
                                    }}>
                                    <EditRounded />
                                </IconButton>
                                <IconButton
                                    style={{ color: theme.palette.error.main, position: 'absolute', zIndex: 2, top: '0px', right: '5px' }}
                                    onClick={() => {
                                        if (isFree) openFreeTrialDialog();
                                        else removeTestimonial(idx);
                                    }}>
                                    <HighlightOffOutlined />
                                </IconButton>
                            </>
                        )}
                        <Card variant='outlined' classes={{ root: styles.card }}>
                            <StyledRating value={testimonial.rating} disabled className='mb-2' name={'rating' + idx} />
                            <Typography variant='body2'>{testimonial.comment}</Typography>
                        </Card>
                        {dialog && <TestimonialsDialog isOpen={dialog} onClose={handleDialogClose} testimonial={edtTestimonial} idx={idx} builderType={builderType} />}
                    </Grid>
                    <Grid item container xs={12} justifyContent='center' alignItems='center'>
                        <Box display='flex' flexDirection='column' alignItems='center'>
                            <Avatar classes={{ root: styles.avatar }} src={confData.filesBaseUrl + confData.filesBasePath + '/' + testimonial.userPhoto?.fileName} />
                            <Typography classes={{ root: styles.reviewerName }}>{testimonial.fullName}</Typography>
                            <Typography classes={{ root: styles.reviewerTitle }}>{testimonial.title}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            {freeTrialDialog && (
                <FreeTrialDialog
                    isOpen={freeTrialDialog}
                    onClose={handleCloseFreeTrialDialog}
                />
            )}
        </>
    );
};
